import React from 'react';
import { useController } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import FieldContainer from '@common/FieldContainer';
import { valueRequired } from '@utils/validators/validators';
import classnames from 'classnames/bind';
import styles from '../premium.module.scss';

const cx = classnames.bind(styles);

interface VerificationCodeProps {
  name: string;
  isCertStatusSuccess: boolean;
  checkCertStatus: () => void;
}

const VerificationCode = ({ name, isCertStatusSuccess, checkCertStatus }: VerificationCodeProps) => {
  //인증 코드
  const { field: codeField, fieldState: codeMeta } = useController({
    name,
    defaultValue: '',
    rules: valueRequired,
  });

  return (
    <FieldContainer name={'인증코드 입력'} required={true}>
      <div className={cx('authArea', { hidden: false })}>
        <div className={cx('authInner')}>
          <input
            {...codeField}
            disabled={isCertStatusSuccess}
            type="text"
            className={cx('input', { error: codeMeta.invalid && codeField.value })}
            placeholder={'인증코드를 입력해 주세요.'}
          />
          <div className={cx('btnInfoArea')}>
            <button
              type="button"
              className={cx('btnInfo')}
              onClick={checkCertStatus}
              disabled={codeMeta.invalid || !codeField.value || isCertStatusSuccess}
            >
              {isCertStatusSuccess ? '인증완료' : '확인'}
            </button>
          </div>
          {codeMeta.invalid && (
            <div className={cx('noticeTextArea')}>
              <span className={cx('noticeText', 'error')}>{<ErrorMessage name={name} />}</span>
            </div>
          )}
        </div>
      </div>
    </FieldContainer>
  );
};

export default VerificationCode;
